import { useEffect } from "react";
import { useLocation } from "react-router";
import sysend from "sysend";
import { isIOS } from "../../Utils";

export default function IamsmartAnonSigning() {
    const query = useLocation().search;
    let channel;
    useEffect(() => {
        if (isIOS()) {
            let chanel_key = localStorage.getItem("chanel_key");

            if (chanel_key === "signFa") {
                channel = new BroadcastChannel("signFa");
            } else if (chanel_key === "signMo") {
                channel = new BroadcastChannel("signMo");
            } else if (chanel_key === "signSpot") {
                channel = new BroadcastChannel("signSpot");
            } else {
                channel = new BroadcastChannel("web_channel");
            }

            channel.postMessage({ query: query });
            window.close();
        } else {
            sysend.broadcast("IamsmartAnonSigning", query);
            setTimeout(function () {
                window.close();
            }, 1000);
        }
    }, []);
    return <>IamsmartAnonSigning</>;
}
